import React from "react";
import Navbar from "../../components/layout/Navbar";
import Hero from "../../components/hero/Hero";
import WhyChoose from "../sections/WhyChoose";
import FeaturedMeals from "../../components/sections/FeaturedMeals";
import Steps from "../../components/sections/Steps";
import WhatSay from "../../components/sections/WhatSay";
import Footer from "../../components/layout/Footer";

export default function HomePage() {
  return (
    <>
      <Navbar/>
        <Hero/>
        <WhyChoose/>
        <FeaturedMeals/>
        <Steps/>
        <WhatSay/>
        <Footer/>
    </>
  );
}
